import React from "react";

import { Link } from "react-router";
import "../styles.css"; // Custom styles for the app
import MusicButton from "../music/musicButton";
import { useMusicPlayer } from "../music/musicPlayerContext";

export const AirbudsYearlyHeader = ({hideMenuBanner, showMusic, closeAction }) => {
  const { pauseMusic } = useMusicPlayer();

  const close = async () => {
    if (closeAction) {
      closeAction();
    } else if (typeof webkit !== "undefined") {
      pauseMusic();
      webkit.messageHandlers.airbudsBridge.postMessage('{"close": {}}');
    }
  };

  return (
    <div className="header">
      {!hideMenuBanner && (
        <div className="header-title">
          <Link to="/menu">
            <img
              src={require("../assets/img/airbudsYearly.svg")}
              alt="airbuds yearly recap"
            />
          </Link>
        </div>
      )}

      <div className="header-actions">
        {showMusic && (
          <MusicButton />
        )}

        <div className="close-button">
          <button onClick={close}>
            <img
              src={require("../assets/img/close.svg")}
              alt="close"
            />
          </button>
        </div>
      </div>
    </div>
  );
};